import { jsonFetch } from "../../../lib/helpers";
import { IntegrationName, RoomWithoutIntegration } from "../../../models";
import { getRoomsWithoutIntegrationUrl } from "./api-url.constants";
import { mapRoomsWithoutIntegration } from "./mappers";

// DTO para la respuesta del backend
interface RoomWithoutIntegrationDTO {
  _id: string;
  name: string;
  address: string;
}

interface GetRoomsWithoutIntegrationResponse {
  data: {
    rooms: RoomWithoutIntegrationDTO[];
  };
}

export const getRoomsWithoutIntegration = async (
  ownerId: string,
  integrationType: IntegrationName
): Promise<RoomWithoutIntegration[]> => {
  const response = await jsonFetch<GetRoomsWithoutIntegrationResponse>(
    getRoomsWithoutIntegrationUrl(ownerId, integrationType)
  );
  return response.data.rooms.map(mapRoomsWithoutIntegration);
};
